import { render, staticRenderFns } from "./page-top-bar.vue?vue&type=template&id=2157f1ef&scoped=true&"
import script from "./page-top-bar.vue?vue&type=script&lang=ts&"
export * from "./page-top-bar.vue?vue&type=script&lang=ts&"
import style0 from "./page-top-bar.vue?vue&type=style&index=0&id=2157f1ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157f1ef",
  null
  
)

export default component.exports